import { render, staticRenderFns } from "./GalleryPreview.vue?vue&type=template&id=35c87794"
import script from "./GalleryPreview.vue?vue&type=script&lang=js"
export * from "./GalleryPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports